export default __webpack_public_path__ + "static/media/close-icon.c6b75439.svg";